export default "__VITE_ASSET__BcviyszX__"